var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [
          _c(
            "gg-card-title",
            {
              staticClass: "pb-0 pt-0"
            },
            [_vm._v(_vm._s(_vm.$route.meta.pageTitle))]
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "text-md-right pb-2",
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [
          _c(
            "gg-btn",
            {
              staticClass: "mt-1",
              attrs: {
                tile: "",
                color: "primary",
                to: {
                  name: "hosting_kvm_order"
                }
              }
            },
            [_vm._v(" Add Server ")]
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-header",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            md: "6"
                          }
                        },
                        [_vm._v(" My Servers ")]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "d-flex flex-sm-row flex-column justify-end align-start gap-sm align-md-center",
                          attrs: {
                            md: "6"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "w-100",
                              staticStyle: {
                                "max-width": "440px"
                              }
                            },
                            [
                              _c("services-search", {
                                attrs: {
                                  compact: ""
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function callback($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.rows,
                      search: _vm.search,
                      "footer-props": {
                        itemsPerPageOptions: _vm.pagination
                      },
                      "no-data-text": "You don't have any servers yet.",
                      "sort-by": "displayName"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.displayName",
                        fn: function fn(_ref) {
                          var item = _ref.item
                          return [
                            _c(
                              "div",
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "ggs-item-title",
                                    attrs: {
                                      to: _vm.manageRoute(item)
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(item.displayName) + " ")]
                                ),
                                item.domain && item.name
                                  ? [
                                      _c("br"),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "caption"
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        }
                      },
                      {
                        key: "item.status",
                        fn: function fn(_ref2) {
                          var item = _ref2.item
                          return [
                            _c(
                              "v-icon",
                              {
                                staticClass: "pb-1",
                                attrs: {
                                  small: "",
                                  color: _vm.statusColor(item.status)
                                }
                              },
                              [_vm._v("mdi-circle")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "pl-1"
                              },
                              [_vm._v(_vm._s(item.status))]
                            )
                          ]
                        }
                      },
                      {
                        key: "item.groupname",
                        fn: function fn(_ref3) {
                          var item = _ref3.item
                          return [
                            _vm._v(" " + _vm._s(item.groupname || "—") + " ")
                          ]
                        }
                      },
                      {
                        key: "item.actions",
                        fn: function fn(_ref4) {
                          var item = _ref4.item
                          return [
                            _c(
                              "gg-btn",
                              {
                                staticClass: "mr-1",
                                attrs: {
                                  to: _vm.manageRoute(item)
                                }
                              },
                              [_vm._v(" Manage ")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }